import { User, UserRole } from './auth';

export type AccountStatus = 'active' | 'locked' | 'suspended';

export interface Account {
    id: string;
    account_name: string;
    status: AccountStatus;
    created_at: string;
    updated_at: string;
}

export interface AccountCreate {
    account_name: string;
}

export interface AccountUpdate {
    account_name?: string;
}

export interface AccountListResponse {
    accounts: Account[];
    total: number;
}

export interface AccountSwitchResponse {
    access_token: string;
    refresh_token: string;
    token_type: string;
    expires_in: number;
    account: Account;
    home_account_id: string;
}

export interface AccountUserCreate {
    username: string;
    email: string;
    role: UserRole;
}

export interface AccountUserListResponse {
    users: User[];
    total: number;
}

export interface AccountsState {
    accounts: Account[];
    total: number;
    isLoading: boolean;
    error: string | null;
    // Per-row in-flight tracking (lock/unlock/switch/edit on a given account id).
    mutatingIds: string[];
    // Account switch (impersonation) in flight.
    isSwitching: boolean;
    // Users nested under an account (loaded lazily on row expand).
    usersByAccount: Record<string, User[]>;
    loadingUsersFor: string[];
    // Impersonation state, mirrored to localStorage so it survives reloads.
    impersonatedAccountId: string | null;
    impersonatedAccountName: string | null;
    homeAccountId: string | null;
}

// localStorage keys for impersonation state (the JWT carries the claim, but the
// client never decodes it, so the banner/exit affordance reads these instead).
export const IMPERSONATED_ACCOUNT_KEY = 'impersonated_account_id';
export const IMPERSONATED_ACCOUNT_NAME_KEY = 'impersonated_account_name';
export const HOME_ACCOUNT_KEY = 'home_account_id';
